export enum OrderStatus {
  Processing = 'processing',
  PartiallyPaid = 'partially-paid',
  Paid = 'paid',
  Unpaid = 'unpaid',
  Delivered = 'delivered',
  Canceled = 'canceled',
  Expired = 'expired',
  Failed = 'failed',
  Refunded = 'refunded',
  PartiallyRefunded = 'refunded-partially',
}

export const orderStatusOptions = [
  { text: 'orders.statuses.' + OrderStatus.Processing, val: OrderStatus.Processing },
  { text: 'orders.statuses.' + OrderStatus.PartiallyPaid, val: OrderStatus.PartiallyPaid },
  { text: 'orders.statuses.' + OrderStatus.Paid, val: OrderStatus.Paid },
  { text: 'orders.statuses.' + OrderStatus.Unpaid, val: OrderStatus.Unpaid },
  { text: 'orders.statuses.' + OrderStatus.Delivered, val: OrderStatus.Delivered },
  { text: 'orders.statuses.' + OrderStatus.Canceled, val: OrderStatus.Canceled },
  { text: 'orders.statuses.' + OrderStatus.Expired, val: OrderStatus.Expired },
  { text: 'orders.statuses.' + OrderStatus.Failed, val: OrderStatus.Failed },
  { text: 'orders.statuses.' + OrderStatus.Refunded, val: OrderStatus.Refunded },
  { text: 'orders.statuses.' + OrderStatus.PartiallyRefunded, val: OrderStatus.PartiallyRefunded },
];

export enum OrderScanStatus {
  NotScanned = 0,
  Scanned = 1,
}

export const orderScanStatusOptions = [
  { text: 'orders.scan_statuses.not_scanned', val: OrderScanStatus.NotScanned },
  { text: 'orders.scan_statuses.scanned', val: OrderScanStatus.Scanned },
];

export enum OrderChannel {
  Physical = 0,
  Online = 1,
}

export enum OrderConfirmationStatus {
  NotReady = 'not-ready',
  ConfirmationReady = 'confirmation-ready',
  Confirmed = 'confirmed',
}

export enum OrderEmailStatus {
  Pending = 'pending',
  Delivered = 'delivered',
  Opened = 'opened',
  Clicked = 'clicked',
  Failed = 'failed',
}

export const orderChannelOptions = [
  { text: 'orders.channels.physical', val: OrderChannel.Physical },
  { text: 'orders.channels.online', val: OrderChannel.Online },
];

export const orderChannelTranslations: Record<OrderChannel, string> = {
  [OrderChannel.Physical]: 'orders.channels.physical',
  [OrderChannel.Online]: 'orders.channels.online',
};
